var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"exit",style:(_vm.transparentColor),attrs:{"href":"/"}},[_c('div',{staticClass:"text"},[_vm._v("Exit")]),_c('div',{staticClass:"icon"},[_c('IconBase',{attrs:{"icon-name":"exit","iconColor":"#2d2d2d","viewBox":"0 0 512.016 512","width":"100%","height":"100%","strokeWidth":"0px"}},[_c('IconLeave')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }